import { User } from "lucide-react";
import React from "react";

type AvatarSize = "xxxs" | "xxs" | "xs" | "sm" | "md" | "lg" | "xl";

interface AlternativeDefaultAvatarProps {
  userId: string;
  displayName?: string; 
  size?: AvatarSize; 
}

// Map sizes to container dimensions and explicit icon sizes
const sizeMap: Record<AvatarSize, { container: string; icon: number }> = {
  xxxs: { container: "w-6 h-6", icon: 14 },
  xxs: { container: "w-8 h-8", icon: 16 },
  xs: { container: "w-10 h-10", icon: 20 },
  sm: { container: "w-12 h-12", icon: 24 },
  md: { container: "w-20 h-20", icon: 40 },
  lg: { container: "w-32 h-32", icon: 64 },
  xl: { container: "w-48 h-48", icon: 96 },
};

const AlternativeDefaultAvatar: React.FC<AlternativeDefaultAvatarProps> = ({
  displayName,
  size = "md",
}) => {
  const config = sizeMap[size] || sizeMap.md;

  return (
    <div
      className={`flex items-center justify-center shrink-0 bg-gray-100 dark:bg-[#262a36] text-gray-400 dark:text-zinc-400 border-0 shadow-none rounded-lg overflow-hidden transition-colors ${config.container}`}
    >
      <User size={config.icon} strokeWidth={2} />
    </div>
  );
};

export default AlternativeDefaultAvatar;
